import React from "react";
import { FaRegLightbulb, FaBullseye, FaMicroscope, FaLayerGroup } from "react-icons/fa";
import "../styles/OverviewSection.css";

const overviewData = [
  {
    icon: <FaRegLightbulb />,
    title: "Overview",
    content:
      "Relison Pharma is a next-generation pharmaceutical company committed to transforming healthcare through innovation, quality, and affordable medicines.",
  },
  {
    icon: <FaBullseye />,
    title: "Our Vision",
    content:
      "To become a global leader in healthcare innovation where science and compassion merge to enhance lives across all communities.",
  },
  {
    icon: <FaMicroscope />,
    title: "Our Mission",
    content:
      "To provide research-driven, technology-powered pharmaceutical solutions that are accessible, reliable, and rooted in trust.",
  },
  {
    icon: <FaLayerGroup />,
    title: "Core Pillars",
    content:
      "Innovation, quality assurance, affordability, and global outreach form the foundation of everything we do.",
  },
];

const OverviewSection = () => {
  return (
    <section className="modern-overview-section">
      <h2>Relison Pharma</h2>
      <p className="section-subtitle">“Serving Human Lives. Care Within Reach.”</p>
      <div className="overview-grid">
        {overviewData.map((item, index) => (
          <div key={index} className="overview-card">
            <div className="icon-wrapper">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.content}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OverviewSection;
